'use strict'
import Vue from 'vue'
import * as d3 from 'd3'
import utils from '../utils'

var exports = {}

var range = (state,s_obj)=>{
  var keys = Object.keys(s_obj)
  keys.sort( (k1,k2)=>{return s_obj[k1].y_position - s_obj[k2].y_position})

  var begin = s_obj[keys[0]],
      end = s_obj[keys.slice(-1)]
  return [begin ? begin.y_position : 0.,
          end ? end.bottom(state) : 0.]
}

exports.fixup_group = (state,group_obj)=>{

  var keys = Object.keys(group_obj)

  var min_y = (k)=>{
    if (group_obj[k].name.includes('*')){
      return utils.hashCode(group_obj[k].name.split('_')[0])
    }
    var out = d3.min(group_obj[k].target_links,l=>l.source.parent.y_position)
    out += d3.min(group_obj[k].target_links,l=>l.source.source_links.indexOf(l))
    if (!out) return 1e9
    return out
  }

  keys = keys.sort( (k1,k2)=> min_y(k1)-min_y(k2))

  for(var i=0;i<keys.length-1;++i){
    var n=group_obj[keys[i]]
    var nn=group_obj[keys[i+1]]
    var bottom = (n.bottom(state))
    Vue.set(nn,'y_position',(bottom+(n.get_value()>1e-4?state.node_padding:0)))
  }

}

exports.fixup_column = (state,col_obj)=>{
  var keys = Object.keys(col_obj)
  keys = keys.sort( (s1,s2) =>{

    if(col_obj[s1][0].is_reserves){
      return 9e29
    }
    if(col_obj[s2][0].is_reserves){
      return -9e29
    }

    if(col_obj[s1][0].name.includes("*waste*") || col_obj[s1][0].name.includes("overhead_") || col_obj[s1][0].name.includes("overhead"))
      return -9e9
    if(col_obj[s2][0].name.includes("*waste*") || col_obj[s2][0].name.includes("overhead_") || col_obj[s2][0].name.includes("overhead"))
      return 9e9

    if(col_obj[s1][0].name.includes("*energy services*")){
      return 9e9
    }else if(col_obj[s2][0].name.includes("*energy services*")) {
      return -9e9
    }
    return  range(state,col_obj[s1])[0] - range(state,col_obj[s2])[0]
  })

  var initial_min = range(state, col_obj[keys[0]])[0]
  if (0 && col_obj[keys[0]][0].is_reserves){
    var rr = range(state, col_obj[keys[0]])
    Object.values(col_obj[keys[0]]).forEach( (n)=>{Vue.set(n,'y_position',n.y_position - rr[0] -(rr[1]-rr[0])) } )
    initial_min = range(state, col_obj[keys[1]])[0]
  }else{
    Object.values(col_obj[keys[0]]).forEach( (n)=>{Vue.set(n,'y_position',n.y_position - initial_min) } )
  }
  for(var i=1;i<keys.length;++i){
    var s=col_obj[keys[i-1]],
        r1=range(state,s),
        ss=col_obj[keys[i]],
        r2=range(state,ss)

    var separate = d3.sum(Object.values(ss),cn=>{return cn.get_value()})
    Object.values(ss).forEach( (n)=>{Vue.set(n,'y_position',n.y_position  - (r2[0]-r1[1]) + state.group_separation ) } )
    if(separate <1e-3)
      Object.values(ss).forEach( (n)=>{Vue.set(n,'y_position',n.y_position  -  state.group_separation ) } )
  }
}


export default exports



//////////////////
// WEBPACK FOOTER
// ./src/store/helpers.js
// module id = null
// module chunks = 